var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('alert-modal',{ref:"alert"}),_c('modal',{staticClass:"alert",attrs:{"active":_vm.active,"title":_vm.title,"confirm":_vm.confirm,"closable":_vm.closable},on:{"close":_vm.close}},[_c('ShareLinks',{attrs:{"event":_vm.event}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }